// extracted by mini-css-extract-plugin
module.exports = {"form":"VerifyBusiness_form__pTv7i","actionButtonContainer":"VerifyBusiness_actionButtonContainer__z-h_R"};